'use client';
import { FC, PropsWithChildren, ReactNode, useEffect, useState } from 'react';

export const ClientOnly: FC<PropsWithChildren<{ placeholder?: ReactNode }>> = ({
  children,
  placeholder = null,
}) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return <>{placeholder ?? null}</>;
  }
  return <>{children}</>;
};
